<xemex-dialog-shell [title]="'devices.csvExport.title' | translate">
  <form [formGroup]="exportForm" class="csv-export-dialog__form">
    <xemex-date-field
      [label]="'devices.csvExport.startDate' | translate"
      formControlName="startDate"
      [max]="maxDate"
    />

    <xemex-date-field
      [label]="'devices.csvExport.endDate' | translate"
      formControlName="endDate"
      [max]="maxDate"
    />

    @if (isRangeInvalid()) {
      <p class="csv-export-dialog__error">{{ 'devices.csvExport.dateRangeError' | translate }}</p>
    }
    @if (hasError()) {
      <p class="csv-export-dialog__error">{{ 'devices.csvExport.error' | translate }}</p>
    }
  </form>

  <div actions class="csv-export-dialog__actions">
    <xemex-text-button type="button" intent="primary" (click)="onCancel()">
      {{ 'general.btnCancel' | translate }}
    </xemex-text-button>
    <xemex-filled-button
      type="button"
      [loading]="isDownloading()"
      [disabled]="!canDownload()"
      (click)="onDownload()"
    >
      {{ 'devices.csvExport.download' | translate }}
    </xemex-filled-button>
  </div>
</xemex-dialog-shell>
